<template lang="pug">
  v-dialog.grey(v-model="dialog" scrollable max-width="1100")
    template(v-slot:activator="{ on }")
      v-btn(color="primary" @click="$emit('emitTransactions',roundId)" v-on="on" text)
        v-tooltip(top)
          template(v-slot:activator="{ on, attrs }")
            v-icon( v-bind="attrs" v-on="on") mdi-text-box-search-outline
          span {{ translations.title }}
    v-card
      v-card-title.d-flex.flex-nowrap.justify-space-between.headline.text-center(primary-title)
        span {{ translations.title }}
        v-btn(@click="dialog = false" icon)
          v-icon mdi-close
      div.d-flex.justify-center.py-12(v-if="loading")
        v-progress-circular(:size="50" color="primary" indeterminate)
      v-card-text.fantasy__scrollbar.px-2.px-sm-6(v-else)
        v-container.text-center(fluid)
          v-lazy(transition="fade-transition")
            v-row.pa-8.pt-0(justify="center")
              v-col(cols="12")
                v-simple-table(v-if="info.length > 0")
                  template(v-slot:default)
                    thead
                      tr
                        th {{ translations.status }}
                        th {{ translations.created }}
                        th {{ translations.externalReference }}
                        th {{ translations.type }}
                        th {{ translations.amount }}
                        th {{ translations.bonusAmount }}
                        th
                    tbody.text-left
                      tr(v-for="(transaction,i) in info" :key="i")
                        td
                          v-avatar(:color="getColorStatus(transaction.status)" size="25") {{ transaction.status }}
                        td {{ transaction.created }}
                        td {{ transaction.externalReference }}
                        td {{ transaction.type }}
                        td.text-right {{ transaction.amount }} {{ getCurrency(transaction.currency) }}
                        td.text-right {{ completeWithZero(formatLanguageNumber(transaction.bonusAmount)) }}
                        td
                          request-response-dialog(:request="transaction.request", :response="transaction.response")
                p(v-else) {{ translations.empty }}
</template>

<script>

  import RequestResponseDialog from "@/components/dialogs/transactionInfo/requestResponseDialog";
  import { currencyList } from '@/store/variablesGlobals.js';

  export default {
    name: "TransactionInfoDialog",
    components: {RequestResponseDialog},
    props: {
      info: {
        type: Array,
        default: function(){
          return []
        }
      },
      roundId: {
        type: String,
        default: ''
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    data:() => ({
      dialog: false,
      currencyList,
    }),
    computed: {
      translations() {
        return this.$t("components.transactionInfoDialog");
      },
    },
    methods:{
      getColorStatus(val){
        if (val == 'F'){
          return 'green  lighten-3';
        } else if (val == 'E'){
          return 'red lighten-3';
        } else if (val == 'P'){
          return 'yellow lighten-3';
        }
      },
      getCurrency(currentCurrency) {
        let curr = this.currencyList.find(item=> item.value === currentCurrency );
        return curr.text;
      },
    }
  }
</script>

<style lang="sass">
</style>